import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../hooks/UserContext'; // Updated import to use the new UserContext

/**
 * A guard component that checks for a specific permission.
 * If the user has the permission, it renders the child routes.
 * Otherwise, it redirects to the /permission-denied page.
 */
const PermissionGuard = ({ permission }) => {
    // Updated to use the useUser hook and its returned values
    const { hasPermission, loading } = useUser();

    if (loading) {
        return null;
    }

    // Check if the user has the specific permission required for the route
    if (hasPermission(permission)) {
        return <Outlet />; // Render the child component (the protected page)
    } else {
        // If permission is not granted, redirect to the permission denied page
        return <Navigate to="/permission-denied" replace />;
    }
};

export default PermissionGuard;
